import { render, staticRenderFns } from "./CtabEditor.vue?vue&type=template&id=65a77a8e&scoped=true"
import script from "./CtabEditor.vue?vue&type=script&lang=js"
export * from "./CtabEditor.vue?vue&type=script&lang=js"
import style0 from "./CtabEditor.vue?vue&type=style&index=0&id=65a77a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a77a8e",
  null
  
)

export default component.exports